import { NavigationLevels, SocialActions } from '../../types/enums'
import { TrackEvent } from '../../utils/trackingHelpers'

//Navigation tracking event
export interface NavTrackingProps {
  navigationLevel: NavigationLevels
  navigationItem: string
}

export function NavigationTrackingEvent(trackingProps: NavTrackingProps) {
  TrackEvent('navigation_interaction', trackingProps)
}

// Contact interaction event
export interface ContactInteractionProps {
  contactName: string
  contactOption: string
}

export function ContactInteractionEvent(
  trackingProps: ContactInteractionProps,
) {
  TrackEvent('contact_interaction', trackingProps)
}

// Social interaction event
export interface SocialInteractionProps {
  socialAction: SocialActions
  socialPlatform: string
}

export function SocialInteractionEvent(trackingProps: SocialInteractionProps) {
  TrackEvent('social_interaction', trackingProps)
}

// File download event
export interface FileDownloadProps {
  fileExtension: string
  fileName: string
  linkId: string | number
  linkText: string
  linkUrl: string
}

export function FileDownloadEvent(trackingProps: FileDownloadProps) {
  TrackEvent('file_download', trackingProps)
}

// Form submit event
export interface FormSubmitProps {
  formId: string | number
  formName: string
  formDestination: string
  formSubmitText: string
}

export function FormSubmitEvent(trackingProps: FormSubmitProps) {
  TrackEvent('form_submit', trackingProps)
}
